import { render, staticRenderFns } from "./laborSalary.vue?vue&type=template&id=7f1b546f"
import script from "./laborSalary.vue?vue&type=script&lang=js"
export * from "./laborSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports